module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.$emit("selected", _vm.person)
      }
    }
  }, [_vm._t("tile-before-content", function() {
    return [_c('v-list-tile-avatar', [_c('v-avatar', [(_vm.person.profile_picture) ? _c('img', {
      attrs: {
        "src": _vm.person.profile_picture
      }
    }) : _c('v-icon', [_vm._v("\n        account_circle\n      ")])], 1)], 1)]
  }), _vm._v(" "), _c('v-list-tile-content', [_vm._t("tile-title", function() {
    return [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(_vm.person.title) + "\n        " + _vm._s(_vm.person.initials) + "\n        " + _vm._s(_vm.person.first_name) + "\n        " + _vm._s(_vm.person.last_name) + "\n        "), (_vm.person.nickname) ? _c('span', [_vm._v("(" + _vm._s(_vm.person.nickname) + ")")]) : _vm._e()])]
  }), _vm._v(" "), _vm._t("tile-sub-title", function() {
    return [(!_vm.compact) ? _c('v-list-tile-sub-title', [_c('v-icon', [_vm._v("phone")]), _vm._v(" " + _vm._s(_vm.person.cell_phone) + "\n      ")], 1) : _vm._e()]
  }), _vm._v(" "), _vm._t("tile-extra", function() {
    return [(!_vm.compact) ? _c('v-list-tile-sub-title', [_c('v-icon', [_vm._v("email")]), _vm._v(" " + _vm._s(_vm.person.email) + "\n      ")], 1) : _vm._e()]
  })], 2), _vm._v(" "), _vm._t("tile-after-content", function() {
    return [(_vm.withEdit) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("edit", _vm.person)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638ea94a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/PersonListItem.vue
// module id = 1447
// module chunks = 9